import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Cxcencdepcli } from "../cxcinterfaces/cxcencdepcli";
import { Cxcdetdepcli } from "../cxcinterfaces/cxcdetdepcli";
import { CxcdepositocliService } from "../cxcservicios/cxcdepositocli.service";


import { NuevoComponentService } from '../../servicios/nuevo-component.service';
import { AuditoriagralService } from '../../advantage/advantageservices/auditoriagral.service';
import { DatePipe } from '@angular/common';
import { CellEditorPrueba } from '../../advantage/config/cell-edit-prueba';
import { SegMaePermiso } from '../../advantage/advantageinterfaces/segmaepermiso';
import { ConfirmationService, MessageService, SelectItem } from 'primeng';
import { InvbusquedaService } from '../../inv/invservicios/invbusqueda.service';
import { AggridsaciComponent } from '../../advantage/aggridsaci/aggridsaci.component';
import * as XLSX from 'xlsx';//CDPJ
import { PermisosService } from '../../advantage/advantageservices/permisos.service';
import { Cxcdetregcomptmp } from "../cxcinterfaces/cxcdetregcomptmp";
import { isNullOrUndefined } from 'util';
import { UploadfilesService } from '../../advantage/advantageservices/uploadfiles.service';
import { UtilitariosService } from 'src/app/advantage/advantageservices/utilitarios.service';

@Component({
  selector: 'app-cxcdepositocli',
  templateUrl: './cxcdepositocli.component.html',
  styleUrls: ['../../advantage/styles/saciwebtrn.css']
})
export class CxcdepositocliComponent implements OnInit {

  @ViewChild(AggridsaciComponent) aggrid: AggridsaciComponent;
  @ViewChild('inputFile') inputfile: ElementRef

  barraBotones2: boolean;
  botonNuevo: boolean;
  botonGuardar: boolean;
  botonBorrar: boolean;
  botonRegresar: boolean;
  botonPrimero: boolean;
  botonAnterior: boolean;
  botonSiguiente: boolean;
  botonUltimo: boolean;

  indicador: any;
  permisoDepcli: SegMaePermiso;

  lblbannombre;
  lblestado;
  public frameworkComponents;
  rowSelection = 'multiple';
  defaultCxdetdepcli;
  rowStyle;
  largo: string;
  detdepcliSelected: Cxcdetdepcli;
  index = 0;

  displayDialogBus: boolean;
  displayDialogBusquedaFast: boolean;
  types: SelectItem[];
  busquedacampos: any[];
  tabla: string;
  consulta: string;
  arregloCons: any[];
  arregloBus: any[];
  where: string;
  opcion: string;
  spin: boolean;
  datosJson;
  // autorizacion
  claveAuth: string;
  autorizacionCodigo: string;
  bolAutorizacion: boolean;
  displayDialogAutorizacion: boolean;


  columnDefsCxcdepcli = [
    {
      headerName: 'No.', field: 'DETDEPCLI_NUMERO',
      editable: (params) => {
        return false;
      }, cellEditor: 'cellPrueba', width: 68, cellStyle: { textAlign: 'right' },
      onCellDoubleClicked: (params) => {
        //this.abrirBanTrnBanEdit(params.data);
      }
    },
    {
      headerName: 'Fecha', field: 'DETDEPCLI_FECHA',
      editable: (params) => {
        return false;
      }, cellEditor: 'cellPrueba', width: 89, cellStyle: { textAlign: 'left' },
      onCellDoubleClicked: (params) => {
        //this.abrirBanTrnBanEdit(params.data);
      }
    },
    {
      headerName: 'Referencia', field: 'DETDEPCLI_REFERENCIA', editable: (params) => {
        return false;
      }, cellEditor: 'cellPrueba', width: 200, cellStyle: { textAlign: 'left' },
      onCellDoubleClicked: (params) => {
        // this.abrirBanTrnBanEdit(params.data);
      }
    },
    {
      headerName: 'Comprobante', field: 'DETDEPCLI_COMPROBANTE', editable: (params) => {
        return false;
      }, cellEditor: 'cellPrueba', width: 140, cellStyle: { textAlign: 'left' },
      onCellDoubleClicked: (params) => {
        // this.abrirBanTrnBanEdit(params.data);
      }
    },
    {
      headerName: 'Concepto', field: 'DETDEPCLI_CONCEPTO', editable: (params) => {
        return false;
      }, cellEditor: 'cellPrueba', width: 200, cellStyle: { textAlign: 'left' },
      onCellDoubleClicked: (params) => {
        // this.abrirBanTrnBanEdit(params.data);
      }
    },
    {
      headerName: 'Importe', field: 'DETDEPCLI_IMPORTE', editable: (params) => {
        return false;
      }, cellEditor: 'cellPrueba', width: 95, cellStyle: { textAlign: 'right' },
      onCellDoubleClicked: (params) => {
        ///this.abrirBanTrnBanEdit(params.data);
      }
    },
    {
      headerName: 'Cliente', field: 'CLI_CODIGO', editable: (params) => {
        return this.validaciboolena(params)
      }, cellEditor: 'cellPrueba', width: 95,
      cellStyle: { textAlign: 'left' },
      cellEditorParams:
      {

        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: true,
          fecha: false,
          clave: false,
          tamanocelda: 20,
          opcionbuscar: true
        }

      }
    },
    {
      headerName: 'Nombre', field: 'CLI_NOMBRE', editable: (params) => {
        return false;
      }, cellEditor: 'cellPrueba', width: 200, cellStyle: { textAlign: 'left' },
      onCellDoubleClicked: (params) => {
        // this.abrirBanTrnBanEdit(params.data);
      }
    },
    // {
    //   headerName: 'Referencia', field: 'DETDEPCLI_REFERENCIA2', editable: (params) => {
    //     return this.validaciboolena(params)
    //   }, cellEditor: 'cellPrueba', width: 200, cellStyle: { textAlign: 'left' },
    //   cellEditorParams:
    //   {
    //     values: {
    //       mayusculas: false,
    //       numeros: true,
    //       alphabetic: true,
    //       saltoslinea: 1,
    //       newrow: false,
    //       numerodecimales: 0,
    //       obligatorio: true,
    //       fecha: false,
    //       clave: false,
    //       tamanocelda: 100
    //     }
    //   }
    // },
    {
      headerName: 'Anticipo', field: 'TRNCOBRO_NRODOC', editable: (params) => {
        return false;
      }, cellEditor: 'cellPrueba', width: 200, cellStyle: { textAlign: 'left' },
      onCellDoubleClicked: (params) => {
        // this.abrirBanTrnBanEdit(params.data);
      }
    }
  ];
  constructor(
    public init: NuevoComponentService, public cxcdepositocliService: CxcdepositocliService,
    private busquedaSer: InvbusquedaService, private datePipe: DatePipe, private permisosService: PermisosService,
    private messageService: MessageService, private confirmationService: ConfirmationService, private auditoriagral: AuditoriagralService,
    public uploadFileService: UploadfilesService, private utilitariosService: UtilitariosService
  ) {
    this.agTable();
  }
  agTable() {
    this.frameworkComponents = {
      cellPrueba: CellEditorPrueba
    };
    this.rowStyle = (params) => {
      if (params.node.rowIndex % 2 !== 0) {
        return { background: '#D6EAF8' };
      }
    };
    this.rowStyle = (params) => {
      if (params.data.COLOREXISTEDOC === 'Y') {
        return { background: 'rgb(245,236,166)' };
      }
    };
    this.defaultCxdetdepcli = {
      editable: true,
      objeto: 'cxcdepcli',
      resizable: true
    };
  }
  async ngOnInit() {
    this.indicador = this.init.tabs[this.init.tabindex - 1].indice;
    this.barraBotones2 = true;
    this.botonNuevo = false;
    this.botonGuardar = true;
    this.botonBorrar = false;
    this.botonRegresar = true;
    this.botonPrimero = true;
    this.botonAnterior = true;
    this.botonSiguiente = true;
    this.botonUltimo = true;
    this.cxcdepositocliService.encdepcli[this.indicador] = {};
    this.cxcdepositocliService.detdepcli = [];
    this.detdepcliSelected = {};
    this.lblbannombre = '';
    this.largo = '-5800';
    this.cxcdepositocliService.regtotal = Number(0).toFixed(0)
    await this.getPermisos()


  }
  async getPermisos() {
    try {
      const data = await this.permisosService.getPermisosFrm(this.init.tabs[this.init.tabindex - 1].component);
      if (data !== null) {
        if (data[0] !== undefined) {
          this.permisoDepcli = data[0];
        } else {
          this.permisoDepcli = null;
        }
      } else {
        this.permisoDepcli = null;
      }
    } catch (e) {
      this.permisoDepcli = null;
      this.messageService.add({
        key: 'cxcdepcli',
        severity: 'error',
        summary: 'Información',
        detail: 'No se pudo obtener los permisos del formulario'
      });
    }
  }
  manejarSenales(valor) {


    if (valor === 'Primero') {

      this.seleccionarRegistro('P');
    }
    if (valor === 'Anterior') {

      this.seleccionarRegistro('A');
    }
    if (valor === 'Siguiente') {

      this.seleccionarRegistro('S');
    }
    if (valor === 'Ultimo') {

      this.seleccionarRegistro('U');
    }


    if (valor === 'Nuevo') {
      if (this.permisoDepcli.PERTODO === 1) {
        this.nuevo();
      } else {
        if (this.permisoDepcli.PERINSERCION === 1) {
          this.nuevo();
        } else {
          this.messageService.add({
            key: 'cxcdepcli',
            severity: 'error',
            summary: 'Información',
            detail: 'El usuario no tiene permisos de inserción, acción denegada'
          });
        }
      }
    }
    if (valor === 'Guardar') {
      if (this.permisoDepcli.PERTODO === 1) {
        this.validarGuardar();
      } else {
        if (this.permisoDepcli.PERINSERCION === 1) {
          this.validarGuardar();
        } else {
          this.messageService.add({
            key: 'cxcdepcli',
            severity: 'error',
            summary: 'Información',
            detail: 'El usuario no tiene permisos de actualización, acción denegada'
          });
        }
      }
    }
    if (valor === 'Cancelar') {
      this.cancelar()
    }
    if (valor === 'Buscar') {
      if (this.permisoDepcli.PERTODO === 1) {
        this.busqueda();
      } else {
        if (this.permisoDepcli.PERSELECCION === 1) {
          this.busqueda();
        } else {
          this.messageService.add({
            key: 'cxcdepcli',
            severity: 'error',
            summary: 'Información',
            detail: 'El usuario no tiene permisos para consultar, acción denegada'
          });
        }
      }
    }
    if (valor === 'Borrar') {
      if (this.permisoDepcli.PERTODO === 1) {
        let numci = 0
        for (const iterator of this.cxcdepositocliService.detdepcli) {
          if (iterator.TRNCOBRO_NRODOC !== '' && isNullOrUndefined(iterator.TRNCOBRO_NRODOC) === false) {
            numci++
          }
        }
        if (numci > 0) {
          this.messageService.add({
            key: 'cxcdepcli',
            severity: 'error',
            summary: 'Información',
            detail: 'No se puede eliminar todo el documento porque ya se generaron los anticipos'
          });
          return;
        }

        this.borrar();
      } else {
        if (this.permisoDepcli.PERELIMACION === 1) {
          let numci = 0
          for (const iterator of this.cxcdepositocliService.detdepcli) {
            if (iterator.TRNCOBRO_NRODOC !== '' && isNullOrUndefined(iterator.TRNCOBRO_NRODOC) === false) {
              numci++
            }
          }
          if (numci > 0) {
            this.messageService.add({
              key: 'cxcdepcli',
              severity: 'error',
              summary: 'Información',
              detail: 'No se puede eliminar todo el registro ya que existen documentos registrados en cartera'
            });
            return;
          }
          this.borrar();
        } else {
          this.messageService.add({
            key: 'cxcdepcli',
            severity: 'error',
            summary: 'Información',
            detail: 'El usuario no tiene permisos de eliminación, acción denegada'
          });
        }
      }
    }

    if (valor === 'Descargar') {
      this.descargarDemo()
    }
    if (valor === 'Generaanc') {
      if (this.botonGuardar === false) {
        this.messageService.add({
          key: 'cxcdepcli',
          severity: 'error',
          summary: 'Error',
          detail: 'Guarde primero el documento por favor'
        });
        return
      }
      this.validadanticipos()
    }
    if (valor === 'Reversaanc') {
      if (this.botonGuardar === false) {
        this.messageService.add({
          key: 'cxcdepcli',
          severity: 'error',
          summary: 'Error',
          detail: 'Guarde primero el documento por favor'
        });
        return
      }
      this.validareversoanc()
    }
    if (valor === 'Salir') {
      this.init.tabs.splice(this.init.tabindex, 1);
    }
  }
  validareversoanc() {
    if (this.cxcdepositocliService.detdepcli.length === 0) {
      this.messageService.add({
        key: 'cxcdepcli',
        severity: 'error',
        summary: 'Error',
        detail: 'El detalle está vacío'
      });
      return;
    }
    this.autorizacionCodigo = 'RVSANCDC'
    this.displayDialogAutorizacion = true;
  }
  async validadanticipos() {
    try {
      const data = await this.cxcdepositocliService.getvencodigo()
      if (data !== null) {
        for (const iterator of data) {
          if (iterator.NUMERO === 0) {
            this.messageService.add({
              key: 'cxcdepcli',
              severity: 'error',
              summary: 'Error',
              detail: 'Debe asignar el vendedor al usuario antes de generar los anticipos'
            });
            return;
          }
        }
      } else {
        this.messageService.add({
          key: 'cxcdepcli',
          severity: 'error',
          summary: 'Error',
          detail: 'Debe registrar el vendedor al usuario'
        });
        return;
      }
      const cedulasnull = Array.from(new Set(this.cxcdepositocliService.detdepcli.map(item =>
        item.CLI_CODIGO).filter(x => x === null || String(x).trim() === '')));

      const trndocs = Array.from(new Set(this.cxcdepositocliService.detdepcli.map(item =>
        item.TRNCOBRO_NRODOC).filter(x => x !== null && String(x).trim() !== '')));

      if (cedulasnull.length > 0) {
        this.messageService.add({
          key: 'cxcdepcli',
          severity: 'error',
          summary: 'Error',
          detail: 'Existen registros con un cliente vacío, por favor regístrelo'
        });
        return;
      }
      if (this.cxcdepositocliService.detdepcli.length === 0) {
        this.messageService.add({
          key: 'cxcdepcli',
          severity: 'error',
          summary: 'Error',
          detail: 'El detalle está vacío'
        });
        return;
      }
      if (trndocs.length > 0) {
        this.messageService.add({
          key: 'cxcdepcli',
          severity: 'error',
          summary: 'Error',
          detail: 'Los anticipos ya han sido generados'
        });
        return;
      }

      this.autorizacionCodigo = 'GNEANCDC'
      this.displayDialogAutorizacion = true;
    } catch (error) {
      this.messageService.add({
        key: 'cxcdepcli',
        severity: 'error',
        summary: 'Error',
        detail: 'Orurrió un error al generar los anticipos ' + error
      });
      return;
    }
  }
  onHideAutorizacion() {
    if (this.bolAutorizacion === false) {
      if (this.autorizacionCodigo === 'GNEANCDC') {
        this.messageService.add({
          key: 'cxcdepcli',
          severity: 'error',
          summary: 'Información',
          detail: 'Debe ingresar correctamente para generar los anticipos'

        });
      }
      if (this.autorizacionCodigo === 'RVSANCDC') {
        this.messageService.add({
          key: 'cxcdepcli',
          severity: 'error',
          summary: 'Información',
          detail: 'Debe ingresar correctamente para reversar los anticipos'

        });
      }
    }
  }
  comprobarClave() {
    this.utilitariosService.obtenerClave(this.autorizacionCodigo).subscribe((clave) => {
      let claveReal;
      claveReal = clave[0].AUTORIZACION_CLAVE;
      if (claveReal === this.claveAuth) {
        if (this.autorizacionCodigo === 'GNEANCDC') {
          this.displayDialogAutorizacion = false;
          this.claveAuth = '';
          this.generaranticipos();
        }
        if (this.autorizacionCodigo === 'RVSANCDC') {
          this.displayDialogAutorizacion = false;
          this.claveAuth = '';
          this.reversaranticipos();
        }
      } else if (clave !== this.claveAuth) {
        this.messageService.add({
          key: 'autorizacion',
          severity: 'error',
          summary: 'Clave Autorización',
          detail: 'La clave que se ingresó es incorrecta, intente nuevamente'
        });
      }
    });
  }
  async generaranticipos() {
    try {
      this.spin = true
      this.messageService.add({
        key: 'cxcdepcli',
        severity: 'success',
        summary: 'Información',
        detail: 'Éxito al iniciar el proceso para generar los anticipos, le informaremos por correo cuando finalice. '
      });
      this.spin = false
      await this.cxcdepositocliService.generaranticipos(this.cxcdepositocliService.encdepcli[this.indicador].ENCDEPCLI_NUMERO);
      await this.auditoriagral.registrarAuditoria('CXC_ENCDEPCLI',
        this.cxcdepositocliService.encdepcli[this.indicador].ENCDEPCLI_NUMERO + '/ANTICIPOS-GENERADOS', 'I',
        '', '01', '', '', '', '').toPromise();
      await this.cancelar();


    } catch (error) {
      this.messageService.add({
        key: 'cxcdepcli',
        severity: 'error',
        summary: 'Error',
        detail: 'Ocurrió un error al generar los anticipos' + error
      });
      this.spin = false
    }
  }
  async reversaranticipos() {
    try {
      this.spin = true
      this.messageService.add({
        key: 'cxcdepcli',
        severity: 'info',
        summary: 'Información',
        detail: 'Éxito al iniciar el proceso para reversar los anticipos, le informaremos por correo cuando finalice. '
      });
      this.spin = false
      await this.cxcdepositocliService.reversaranticipos(this.cxcdepositocliService.encdepcli[this.indicador].ENCDEPCLI_NUMERO);
      await this.auditoriagral.registrarAuditoria('CXC_ENCDEPCLI',
        this.cxcdepositocliService.encdepcli[this.indicador].ENCDEPCLI_NUMERO + '/ANTICIPOS-REVERSADOS', 'E',
        '', '01', '', '', '', '').toPromise();
      await this.cancelar();
      // console.log(data[0][':B1'])
      // let numreg = data[0][':B1']

      // if (Number(numreg) === 0) {


      //   await this.auditoriagral.registrarAuditoria('CXC_ENCDEPCLI',
      //     this.cxcdepositocliService.encdepcli[this.indicador].ENCDEPCLI_NUMERO + '/ANTICIPOS-REVERSADOS', 'E',
      //     '', '01', '', '', '', '').toPromise();
      //   await this.cancelar()
      //   this.messageService.add({
      //     key: 'cxcdepcli',
      //     severity: 'success',
      //     summary: 'Información',
      //     detail: 'Éxito al reversar los anticipos '
      //   });

      // } else {
      //   this.messageService.add({
      //     key: 'cxcdepcli',
      //     severity: 'error',
      //     summary: 'Error',
      //     detail: 'No se pueden reversar los anticipos porque ya han sido utlizados en cartera activa'
      //   });
      // }
    } catch (error) {
      this.spin = false

      // this.messageService.add({
      //   key: 'cxcdepcli',
      //   severity: 'error',
      //   summary: 'Error',
      //   detail: 'Ocurrió un error al reversar los anticipos, revise su correo por favor '
      // });
      console.log(error)
      this.spin = false
    }
  }
  seleccionarRegistro(strTipo) {

    if (strTipo === 'P') {
      this.botonPrimero = false;
      this.botonAnterior = false;
      this.botonSiguiente = true;
      this.botonUltimo = true;
    }
    if (strTipo === 'A' || strTipo === 'S') {
      this.botonPrimero = true;
      this.botonAnterior = true;
      this.botonSiguiente = true;
      this.botonUltimo = true;
    }
    if (strTipo === 'U') {
      this.botonPrimero = true;
      this.botonAnterior = true;
      this.botonSiguiente = false;
      this.botonUltimo = false;
    }
    let numero = isNullOrUndefined(this.cxcdepositocliService.encdepcli[this.indicador].ENCDEPCLI_NUMERO) ? '' : this.cxcdepositocliService.encdepcli[this.indicador].ENCDEPCLI_NUMERO
    this.cxcdepositocliService.seleccionarRegistro(strTipo, numero).subscribe((datos: any[]) => {
      if (datos !== null && datos.length > 0) {
        this.encontrarregistro(datos[0].ENCDEPCLI_NUMERO);
        //this.encontrarFactura(datos[0], 'sR');

      }
    }, error1 => {

      this.messageService.add({
        key: 'cxcdepcli',
        severity: 'error',
        summary: 'Error',
        detail: 'Ocurrió un error al buscar la información' + error1
      });
    });
  }
  borrar() {
    this.confirmationService.confirm({
      message: 'Está seguro de eliminar el registro?',
      header: 'Pregunta',
      icon: 'pi pi-exclamation-triangle',
      key: 'confirmcxcdepcli',
      acceptLabel: 'Si',
      rejectLabel: 'No',
      accept: async () => {
        this.confirmationService.close();
        try {
          let numci = 0
          let numero = this.cxcdepositocliService.encdepcli[this.indicador].ENCDEPCLI_NUMERO
          for (const iterator of this.cxcdepositocliService.detdepcli) {
            if (iterator.TRNCOBRO_NRODOC !== '' && isNullOrUndefined(iterator.TRNCOBRO_NRODOC) === false) {
              numci++
            }
          }
          if (numci > 0) {
            this.messageService.add({
              key: 'cxcdepcli',
              severity: 'error',
              summary: 'Información',
              detail: 'No se puede eliminar todo el documento ya que existen documentos registrados en cartera'
            });
            return;
          }
          this.cxcdepositocliService.encdepcli[this.indicador].ENCDEPCLI_NUMERO = ''
          await this.cxcdepositocliService.borrarRegistro(numero)
          await this.auditoriagral.registrarAuditoria('CXC_ENCDEPCLI',
            numero + '/Banco:' + this.cxcdepositocliService.encdepcli[this.indicador].BAN_CODIGO, 'E',
            '', '01', '', '', '', '').toPromise();
          await this.cancelar()
          this.messageService.add({
            key: 'cxcdepcli',
            severity: 'success',
            summary: 'Información',
            detail: 'El registro se eliminó de forma correcta'
          });

        } catch (error) {
          this.messageService.add({
            key: 'cxcdepcli',
            severity: 'error',
            summary: 'Información',
            detail: 'Ocurrió un error durante la eliminación ' + error
          });
        }
      },
      reject: () => {
        this.confirmationService.close();
      }
    });
  }
  async validarGuardar() {
    try {
      this.spin = true

      //const cedulas = Array.from(new Set(this.cxcdepositocliService.detdepcli.map(item => String(item.CLI_CODIGO)).filter(x => x !== null && String(x).trim() !== '')));
      //let filtroreg = this.cxcdepositocliService.detdepcli.filter(x => x.COLOREXISTEDOC === 'Y')

      const cedulas = this.cxcdepositocliService.detdepcli.map(({ CLI_CODIGO, DETDEPCLI_COMPROBANTE }) => ({
        CODCLI: CLI_CODIGO,
        COMPROBANTE: DETDEPCLI_COMPROBANTE
      }))

      const bancosdet = Array.from(new Set(this.cxcdepositocliService.detdepcli.map(item => String(item.BAN_CODIGO)).filter(x => x !== null && String(x).trim() !== '')));
      const regAllregistrados = this.cxcdepositocliService.detdepcli.filter(x => x.COLOREXISTEDOC === 'Y');
      if (this.cxcdepositocliService.detdepcli.length === 0) {
        this.messageService.add({
          key: 'cxcdepcli',
          severity: 'error',
          summary: 'Información',
          detail: 'No se puede guardar si el detalle está vacío'
        });
        this.spin = false
        return;
      }
      await this.cxcdepositocliService.insertartmpdepcli(cedulas)


      const data1 = await this.cxcdepositocliService.validacedulas();
      const intNumBanco = await this.cxcdepositocliService.erpBanCliCodigo(this.cxcdepositocliService.encdepcli[this.indicador].BAN_CODIGO);
      const data2 = await this.cxcdepositocliService.validabancosdet(bancosdet);

      if (intNumBanco != null) {
        if (intNumBanco[0] !== undefined) {
          if (intNumBanco[0]['COUNT(*)'] === 0) {
            this.messageService.add({
              key: 'cxcdepcli',
              severity: 'error',
              summary: 'Error',
              detail: 'El Banco no existe'
            });
            //CDPJ
            this.spin = false;
            return
          }
        }
      }
      if (data1 !== null && data1 !== undefined) {
        const cadena = data1.map(item => String(item.CLI_CODIGO)).join(',')
        if (data1.length > 0) {
          if (data1.length === 1) {
            this.messageService.add({
              key: 'cxcdepcli',
              severity: 'error',
              summary: 'Error',
              detail: 'Hubo un error al validar el siguiente código, por favor revisar ' + cadena
            });
          } else {
            this.messageService.add({
              key: 'cxcdepcli',
              severity: 'error',
              summary: 'Error',
              detail: 'Hubo un error al validar los siguientes códigos, por favor revisar ' + cadena
            });
          } 
          this.spin = false
          return;
        }
      }
      if (data2 !== null && data2 !== undefined) {
        if (data2.length > 0) {
          this.messageService.add({
            key: 'cxcdepcli',
            severity: 'error',
            summary: 'Error',
            detail: 'Hubo un error al validar los siguientes bancos en el detalle, por favor revisar ' + data2.join(", ")
          });
          this.spin = false
          return;
        }
      }
      if (regAllregistrados.length === this.cxcdepositocliService.detdepcli.length) {
        this.messageService.add({
          key: 'cxcdepcli',
          severity: 'error',
          summary: 'Información',
          detail: 'Todos los registros que intenta ingresar ya se encuentran en el sistema'
        });
        this.spin = false
        return;
      }
      if (this.cxcdepositocliService.encdepcli[this.indicador].BAN_CODIGO === null ||
        this.cxcdepositocliService.encdepcli[this.indicador].BAN_CODIGO === undefined ||
        String(this.cxcdepositocliService.encdepcli[this.indicador].BAN_CODIGO).trim() === '') {
        this.messageService.add({
          key: 'cxcdepcli',
          severity: 'error',
          summary: 'Información',
          detail: 'El código del banco no puede estar vacío'
        });
        this.spin = false
        return;
      }
      if (this.cxcdepositocliService.encdepcli[this.indicador].ENCDEPCLI_FECHA === null ||
        this.cxcdepositocliService.encdepcli[this.indicador].ENCDEPCLI_FECHA === undefined ||
        this.cxcdepositocliService.encdepcli[this.indicador].ENCDEPCLI_FECHA === '') {
        this.messageService.add({
          key: 'cxcdepcli',
          severity: 'error',
          summary: 'Información',
          detail: 'La fecha no puede estar vacía'
        });
        this.spin = false
        return;
      }


      this.guardar()
    } catch (error) {
      this.messageService.add({
        key: 'cxcdepcli',
        severity: 'error',
        summary: 'Información',
        detail: 'Hubo un error al validar la información antes de guardar ' + error
      });
      this.spin = false
      return;
    }


  }
  async guardar() {
    let numero = this.cxcdepositocliService.encdepcli[this.indicador].ENCDEPCLI_NUMERO
    try {

      if (numero === null || numero === undefined || numero === '') {
        if (this.cxcdepositocliService.encdepcli[this.indicador].ENCDEPCLI_FECHA.toString().includes('-')) {
          this.cxcdepositocliService.encdepcli[this.indicador].ENCDEPCLI_FECHA = this.datePipe.transform(this.cxcdepositocliService.encdepcli[this.indicador].ENCDEPCLI_FECHA, 'dd/MM/yyyy')
        }
        const data = await this.cxcdepositocliService.insertarregistro(this.cxcdepositocliService.encdepcli[this.indicador])
        if (data.length > 0 && data !== null) {

          for (const iterator of data) {
            this.cxcdepositocliService.encdepcli[this.indicador].ENCDEPCLI_NUMERO = iterator.NUMERO

            for (const item of this.cxcdepositocliService.detdepcli) {
              if (item.DETDEPCLI_FECHA.toString().includes('-')) {
                item.DETDEPCLI_FECHA = this.datePipe.transform(item.DETDEPCLI_FECHA, 'dd/MM/yyyy')
              }
              item.DETDEPCLI_IMPORTE = Number(item.DETDEPCLI_IMPORTE);
            }
            let filtroreg = this.cxcdepositocliService.detdepcli.filter(x => x.COLOREXISTEDOC === 'N')

            const areglodet = filtroreg.map(({ COM_CODIGO, BAN_CODIGO,
              DETDEPCLI_FECHA, DETDEPCLI_REFERENCIA, DETDEPCLI_COMPROBANTE, DETDEPCLI_CONCEPTO,
              CLI_CODIGO, DETDEPCLI_IMPORTE }) => ({
                p_ENCDEPCLI_NUMERO: iterator.NUMERO,
                p_COM_CODIGO: COM_CODIGO,
                p_BAN_CODIGO: BAN_CODIGO,
                p_DETDEPCLI_FECHA: DETDEPCLI_FECHA,
                p_DETDEPCLI_REFERENCIA: DETDEPCLI_REFERENCIA,
                p_DETDEPCLI_COMPROBANTE: DETDEPCLI_COMPROBANTE,
                p_DETDEPCLI_CONCEPTO: DETDEPCLI_CONCEPTO,
                p_CLI_CODIGO: CLI_CODIGO,
                p_DETDEPCLI_IMPORTE: DETDEPCLI_IMPORTE,
                p_USU_identificacion_4: this.cxcdepositocliService.usuario.identificacion,
                p_AUD_equipo: this.utilitariosService.getHostname(),
                p_AUD_ippublica: this.utilitariosService.getIpFrontend()
              }))
            await this.auditoriagral.registrarAuditoria('CXC_ENCDEPCLI',
              iterator.NUMERO + '/' + this.cxcdepositocliService.encdepcli[this.indicador].BAN_CODIGO, 'I',
              '', '01', '', '', '', '').toPromise();
            await this.cxcdepositocliService.insertarregistrodet(areglodet)
          }

          this.messageService.add({
            key: 'cxcdepcli',
            severity: 'success',
            summary: 'Información',
            detail: 'Éxito al guardar '
          });
          this.botonNuevo = false;
          this.botonGuardar = true;
          this.botonBorrar = false;
          this.botonRegresar = true;
          this.botonPrimero = true;
          this.botonAnterior = true;
          this.botonSiguiente = true;
          this.botonUltimo = true;
          await this.cancelar()
        }
      } else {
        if (this.cxcdepositocliService.encdepcli[this.indicador].ENCDEPCLI_FECHA.toString().includes('-')) {
          this.cxcdepositocliService.encdepcli[this.indicador].ENCDEPCLI_FECHA = this.datePipe.transform(this.cxcdepositocliService.encdepcli[this.indicador].ENCDEPCLI_FECHA, 'dd/MM/yyyy')
        }
        const data = await this.cxcdepositocliService.actualizarregistro(this.cxcdepositocliService.encdepcli[this.indicador])
        if (data.length > 0 && data !== null) {

          for (const iterator of data) {
            this.cxcdepositocliService.encdepcli[this.indicador].ENCDEPCLI_NUMERO = iterator.NUMERO

            for (const item of this.cxcdepositocliService.detdepcli) {
              if (item.DETDEPCLI_FECHA.toString().includes('-')) {
                item.DETDEPCLI_FECHA = this.datePipe.transform(item.DETDEPCLI_FECHA, 'dd/MM/yyyy')
              }
              item.DETDEPCLI_IMPORTE = Number(item.DETDEPCLI_IMPORTE);
            }
            let filtroreg = this.cxcdepositocliService.detdepcli.filter(x => x.COLOREXISTEDOC === 'N')
            let filtroact = filtroreg.filter(x => x.NUEVO === 'N')
            let filtronew = filtroreg.filter(x => x.NUEVO === 'Y')

            await this.auditoriagral.registrarAuditoria('CXC_ENCDEPCLI',
              iterator.NUMERO + '/' + this.cxcdepositocliService.encdepcli[this.indicador].BAN_CODIGO, 'A',
              '', '01', '', '', '', '').toPromise();
            if (filtroact.length > 0) {
              const areglodet = filtroact.map(({ COM_CODIGO, BAN_CODIGO,
                DETDEPCLI_REFERENCIA, DETDEPCLI_COMPROBANTE,
                CLI_CODIGO }) => ({
                  p_ENCDEPCLI_NUMERO: iterator.NUMERO,
                  p_COM_CODIGO: COM_CODIGO,
                  p_DETDEPCLI_REFERENCIA: DETDEPCLI_REFERENCIA,
                  p_BAN_CODIGO: BAN_CODIGO,
                  p_DETDEPCLI_COMPROBANTE: DETDEPCLI_COMPROBANTE,
                  p_CLI_CODIGO: CLI_CODIGO,
                  p_USU_identificacion_4: this.cxcdepositocliService.usuario.identificacion,
                  p_AUD_equipo: this.utilitariosService.getHostname(),
                  p_AUD_ippublica: this.utilitariosService.getIpFrontend()
                }))
              await this.cxcdepositocliService.actualizarregistrodet(areglodet)
            }
            if (filtronew.length > 0) {
              const areglodet = filtroreg.map(({ COM_CODIGO, BAN_CODIGO,
                DETDEPCLI_FECHA, DETDEPCLI_REFERENCIA, DETDEPCLI_COMPROBANTE, DETDEPCLI_CONCEPTO,
                CLI_CODIGO, DETDEPCLI_IMPORTE }) => ({
                  p_ENCDEPCLI_NUMERO: iterator.NUMERO,
                  p_COM_CODIGO: COM_CODIGO,
                  p_BAN_CODIGO: BAN_CODIGO,
                  p_DETDEPCLI_FECHA: DETDEPCLI_FECHA,
                  p_DETDEPCLI_REFERENCIA: DETDEPCLI_REFERENCIA,
                  p_DETDEPCLI_COMPROBANTE: DETDEPCLI_COMPROBANTE,
                  p_DETDEPCLI_CONCEPTO: DETDEPCLI_CONCEPTO,
                  p_CLI_CODIGO: CLI_CODIGO,
                  p_DETDEPCLI_IMPORTE: DETDEPCLI_IMPORTE,
                  p_USU_identificacion_4: this.cxcdepositocliService.usuario.identificacion,
                  p_AUD_equipo: this.utilitariosService.getHostname(),
                  p_AUD_ippublica: this.utilitariosService.getIpFrontend()
                }));
              await this.cxcdepositocliService.insertarregistrodet(areglodet)
            }
          }

          this.messageService.add({
            key: 'cxcdepcli',
            severity: 'success',
            summary: 'Información',
            detail: 'Éxito al guardar '
          });
          this.botonNuevo = false;
          this.botonGuardar = true;
          this.botonBorrar = false;
          this.botonRegresar = true;
          this.botonPrimero = true;
          this.botonAnterior = true;
          this.botonSiguiente = true;
          this.botonUltimo = true;
          await this.cancelar()
        }
      }
    } catch (error) {
      this.messageService.add({
        key: 'cxcdepcli',
        severity: 'error',
        summary: 'Información',
        detail: 'Ocurrió un error al gurdar la información' + error
      });
      this.spin = false
    }
  }
  nuevo() {
    this.botonNuevo = true;
    this.botonGuardar = false;
    this.botonBorrar = true;
    this.botonRegresar = false;
    this.botonPrimero = false;
    this.botonAnterior = false;
    this.botonSiguiente = false;
    this.botonUltimo = false;
    this.lblbannombre = '';
    this.lblestado = 'PENDIENTE';

    this.cxcdepositocliService.encdepcli[this.indicador] = {
      ENCDEPCLI_NUMERO: '',
      COM_CODIGO: '01',
      ENCDEPCLI_FECHA: new Date(),
      ENCDEPCLI_CONCEPTO: '',
      USUIDENTIFICACION: '',
      BAN_CODIGO: '',
      ENCDEPCLI_ESTADO: '0'
    }

    this.cxcdepositocliService.detdepcli = [];
    document.getElementById('contorno').style.pointerEvents = 'all';
    setTimeout(() => {
      document.getElementById('BAN_CODIGO').focus();
    }, 100);

  }

  cancelar() {
    if (isNullOrUndefined(this.cxcdepositocliService.encdepcli[this.indicador].ENCDEPCLI_NUMERO)
      || this.cxcdepositocliService.encdepcli[this.indicador].ENCDEPCLI_NUMERO === '') {
      this.limpiardatos()
    } else {
      this.botonNuevo = false;
      this.botonGuardar = true;
      this.botonBorrar = false;
      this.botonRegresar = true;
      this.botonPrimero = true;
      this.botonAnterior = true;
      this.botonSiguiente = true;
      this.botonUltimo = true;

      this.spin = true;
      this.encontrarregistro(this.cxcdepositocliService.encdepcli[this.indicador].ENCDEPCLI_NUMERO)
    }
  }
  limpiardatos() {
    this.barraBotones2 = true;
    this.botonNuevo = false;
    this.botonGuardar = true;
    this.botonBorrar = false;
    this.botonRegresar = true;
    this.botonPrimero = true;
    this.botonAnterior = true;
    this.botonSiguiente = true;
    this.botonUltimo = true;
    this.cxcdepositocliService.encdepcli[this.indicador] = {};
    this.cxcdepositocliService.detdepcli = [];
    this.detdepcliSelected = {};
    this.lblbannombre = '';
    this.lblestado = '';
    document.getElementById('contorno').style.pointerEvents = 'none';
  }
  async descargarDemo() {
    try {
      const rs: any = await this.uploadFileService.getDocument('REGISTRO_DEPOSITOS_DEMO.xlsx');
      this.downloadDocument(rs.respuesta, 'REGISTRO_DEPOSITOS_DEMO.xlsx');
    } catch (err) {
      this.messageService.add({
        key: 'presuparti',
        severity: 'error',
        summary: 'Información',
        detail: 'Ocurrio un error al encontrar el archivo'
      });
    }
  }
  downloadDocument(strBase64, filename) {
    const byteCharacters = atob(strBase64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/octet-stream' });

    const data = window.URL.createObjectURL(blob);
    let link = document.createElement('a');
    link.href = data;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setTimeout(() => {
      window.URL.revokeObjectURL(data);
    }, 1000)
  }
  changeTabs() {

  }
  busquedabanco(parametro) {
    this.opcion = 'BuscarBanco';
    this.types = [
      { label: 'CÓDIGO', value: 'BAN_CODIGO' },
      { label: 'BANCO', value: 'BAN_BANCO' },
      { label: 'CUENTA NRO', value: 'BAN_CTANRO' },
      { label: 'JEFE CUENTA', value: 'BAN_JEFECTA' },
      { label: 'SUCURSAL', value: 'BAN_SUCURSAL' },
      { label: 'DIRECCIÓN', value: 'BAN_DIRECCION' },
      { label: 'TELEFONO1', value: 'BAN_TELEFONO1' },
      { label: 'REF. CONTABLE', value: 'CON_CODIGO' },
      { label: 'CEN_CODIGO', value: 'CEN_CODIGO' },
      { label: 'TIPO DE CUENTA', value: 'BAN_TIPOCUENTA' },
      { label: 'DOC. POR PAGAR', value: 'CON_CODIGO_2' },
      { label: 'PROCESO', value: 'BAN_PROCESO_CM' },
      { label: 'DIRECTORIOCM', value: 'BAN_DIRECTORIO_CM' },
      { label: 'DINEROELEC', value: 'BAN_DINEROELEC' },
      { label: 'TELCEL', value: 'BAN_TELEFONOCEL' },
      { label: 'ULT. CHEQUE', value: 'BAN_ULTIMOCHEQUE' },
    ];
    this.busquedacampos = [parametro, '', '', '', '', '', '', '', '', '', '', '', '', '', '', ''];
    this.consulta = 'BAN_codigo,BAN_banco, NVL(BAN_ctanro, \'*\') AS BAN_ctanro, BAN_jefecta,BAN_sucursal,' +
      ' BAN_direccion, BAN_telefono1, NVL(CON_codigo, \'\') as CON_codigo, CEN_CODIGO,BAN_tipocuenta,' +
      ' con_codigo_2, ban_proceso_cm, ban_directorio_cm, ban_dineroelec, ban_telefonocel,BAN_ULTIMOCHEQUE';
    this.tabla = 'BAN_MAEBAN';
    this.where = '';

    this.cxcdepositocliService.encontrarBanco(this.types[0].value + ' LIKE \'' + parametro + '\'').subscribe(eR => {
      if (eR !== null) {
        if (eR[0] !== undefined) {
          this.manejarSeleccion(eR[0]);
        } else {
          this.busquedaSer.busquedaBanMaeBan2(parametro).subscribe((res: any[]) => {
            this.arregloCons = res;
            this.displayDialogBusquedaFast = true;
          });
        }
      } else {
        this.busquedaSer.busquedaBanMaeBan2(parametro).subscribe((res: any[]) => {
          this.arregloCons = res;
          this.displayDialogBusquedaFast = true;
        });
      }
    });
  }
  async busqueda() {
    this.opcion = 'BUSCARREG';
    this.types = [
      { label: 'Número', value: 'ENCDEPCLI_NUMERO' },
      { label: 'FECHA', value: 'ENCDEPCLI_FECHA' },
      { label: 'Concepto', value: 'ENCDEPCLI_CONCEPTO' },

    ];
    this.busquedacampos = ['', '', ''];
    this.tabla = 'CXC_ENCDEPCLI';
    this.where = ' ENCDEPCLI_NUMERO is not null order by 1 desc';
    this.busquedaSer.busquedaRegCxcDepcliente().subscribe((res: any[]) => {
      this.arregloCons = res;
      this.arregloCons.map((dato) => {
        if (dato.ENCDEPCLI_FECHA !== null) {
          dato.ENCDEPCLI_FECHA = this.datePipe.transform(dato.ENCDEPCLI_FECHA, 'dd/MM/yyyy');
        } else {
          dato.ENCDEPCLI_FECHA = '';
        }
      });
      this.displayDialogBusquedaFast = true;
    });
  }
  manejarSeleccion(opcion) {
    if (this.opcion === 'BuscarBanco') {
      this.cxcdepositocliService.encdepcli[this.indicador].BAN_CODIGO = opcion.BAN_CODIGO
      this.lblbannombre = opcion.BAN_BANCO;
      document.getElementById('ENCDEPCLI_CONCEPTO').focus();
    }
    if (this.opcion === 'BUSCARREG') {
      this.encontrarregistro(opcion.ENCDEPCLI_NUMERO)
    }
    this.displayDialogBusquedaFast = false
  }
  cambio(params) {
    // this.botonNuevo = true;
    // this.botonGuardar = false;
    // this.botonBorrar = true;
    // this.botonRegresar = false;
    // this.botonPrimero = false;
    // this.botonAnterior = false;
    // this.botonSiguiente = false;
    // this.botonUltimo = false;
  }
  async encontrarregistro(encdepclinumero) {
    try {
      this.botonNuevo = false;
      this.botonGuardar = true;
      this.botonBorrar = false;
      this.botonRegresar = true;
      this.botonPrimero = true;
      this.botonAnterior = true;
      this.botonSiguiente = true;
      this.botonUltimo = true;
      this.spin = true
      const data = await this.cxcdepositocliService.getencdepcli(encdepclinumero)
      const data2 = await this.cxcdepositocliService.getdetdepcli(encdepclinumero)
      if (data.length > 0) {
        this.cxcdepositocliService.encdepcli[this.indicador] = {}
        this.cxcdepositocliService.detdepcli = []
        for (const iterator of data) {
          iterator.ENCDEPCLI_FECHA = new Date(iterator.ENCDEPCLI_FECHA)
          this.lblbannombre = iterator.BAN_NOMBRE
          this.cxcdepositocliService.encdepcli[this.indicador] = iterator
          if (this.cxcdepositocliService.encdepcli[this.indicador].ENCDEPCLI_ESTADO === '0') {
            this.lblestado = 'PENDIENTE'
            document.getElementById('contorno').style.pointerEvents = 'all';
          } else if (this.cxcdepositocliService.encdepcli[this.indicador].ENCDEPCLI_ESTADO === '1') {
            this.lblestado = 'PROCESADO'
            document.getElementById('contorno').style.pointerEvents = 'none';
          }
          if (data2 !== null) {
            let numero = 1;
            for (const item of data2) {
              if (item.DETDEPCLI_FECHA.toString().includes('-')) {
                item.DETDEPCLI_FECHA = this.datePipe.transform(item.DETDEPCLI_FECHA, 'dd/MM/yyyy')
              }
              item.DETDEPCLI_IMPORTE = this.utilitariosService.formatear(item.DETDEPCLI_IMPORTE, 2)
              item.DETDEPCLI_NUMERO = numero
              item.NUEVO = 'N'
              item.COLOREXISTEDOC = 'N'
              numero++;
            }
            this.cxcdepositocliService.detdepcli = data2;
          }

          this.cxcdepositocliService.calculartotal();
          this.spin = false;
        }
      }
    } catch (error) {
      this.messageService.add({
        key: 'cxcdepcli',
        severity: 'error',
        summary: 'Error',
        detail: 'Ocurrió un error al consultar el registro' + error
      });
      this.spin = false
    }
  }
  seleccionItem(params) {
    if (params === 'subirxls') {
      if (this.cxcdepositocliService.encdepcli[this.indicador].BAN_CODIGO === null ||
        this.cxcdepositocliService.encdepcli[this.indicador].BAN_CODIGO === undefined ||
        this.cxcdepositocliService.encdepcli[this.indicador].BAN_CODIGO === '') {
        this.messageService.add({
          key: 'cxcdepcli',
          severity: 'error',
          summary: 'Información',
          detail: 'El código del banco no puede estar vacío'
        });
        return;
      }

      if (this.cxcdepositocliService.encdepcli[this.indicador].ENCDEPCLI_ESTADO === '1') {
        this.messageService.add({
          key: 'cxcdepcli',
          severity: 'error',
          summary: 'Información',
          detail: 'No se pueden cargar más registros porque el documento ya ha sido procesado y los anticipos generados'
        });
        return;
      }
      this.inputfile.nativeElement.click();
      return;
    }
    if (params === 'eliminar') {
      if (this.detdepcliSelected.TRNCOBRO_NRODOC !== '' && isNullOrUndefined(this.detdepcliSelected.TRNCOBRO_NRODOC) === false) {
        this.messageService.add({
          key: 'cxcdepcli',
          severity: 'error',
          summary: 'Información',
          detail: 'No puede eliminar un registro que ya tiene un anticipo'
        });
        return;
      }
      this.confirmeliminaregistro()
      return
    }

    if (params.object !== undefined) {
      this.detdepcliSelected = params.object;
    }
  }

  async onBasicUpload(ev) {
    let validacionVacio = true;
    // console.log(ev[0]);
    // console.log(ev);
    let workBook = null;
    let jsonData = null;
    const reader = new FileReader();
    const file = ev[0];
    reader.onload = async (event) => {
      const data = reader.result;
      workBook = XLSX.read(data, { type: 'binary', cellDates: true, cellNF: false, cellText: false });

      jsonData = workBook.SheetNames.reduce((initial, name) => {
        //console.log(workBook.Sheets[name]);
        const sheet = workBook.Sheets[name];
        initial[name] = XLSX.utils.sheet_to_json(sheet, { defval: '' });
        return initial;
      }, {});
      //console.log(jsonData.Hoja1);

      for (let data of jsonData.Hoja1) {

        delete data.__EMPTY;
        for (let key in data) { // se revisa los campos del json generado del excel,
          // si uno de esos campos no existe o está vacío no se activará el boton de guardar
          if (data[key] === '') {
            validacionVacio = false;
          }

        }
      }
      this.datosJson = jsonData.Hoja1;
      //console.log(this.datosJson)
      this.inputfile.nativeElement.value = ''
      
      await this.validaexcell();

    }
    reader.readAsBinaryString(file);
  }
  async validaexcell() {
    this.spin = true
    try {
      let reg: Cxcdetdepcli = {}
      let numero = 1;
      
      if (this.cxcdepositocliService.encdepcli[this.indicador].ENCDEPCLI_NUMERO === ''
        || isNullOrUndefined(this.cxcdepositocliService.encdepcli[this.indicador].ENCDEPCLI_NUMERO)) {
        this.cxcdepositocliService.detdepcli = []
      }
      const fechanull = Array.from(new Set(this.datosJson.map(item =>
        item.FECHA).filter(x => x === null || String(x).trim() === '')))

      const fechaPosiciones = new Map<string, number[]>();

      this.datosJson.forEach((item, index) => {
        const fecha = item.FECHA
        if (fecha !== null && fecha && String(fecha).trim() !== '') {
          const key = String(fecha).trim();
          if (!fechaPosiciones.has(key)) {
            fechaPosiciones.set(key, [])
          }
          fechaPosiciones.get(key)!.push(index + 2)
        }
      });

      const compnull = Array.from(new Set(this.datosJson.map(item =>
        item.COMPROBANTE).filter(x => x === null || String(x).trim() === '')))

      const codclinull = Array.from(new Set(this.datosJson.map(item =>
        item.CODCLI).filter(x => x === null || String(x).trim() === '')))

      const importenull = Array.from(new Set(this.datosJson.map(item =>
        item.IMPORTE).filter(x => x === null || String(x).trim() === '')))

      if (fechanull.length > 0) {
        this.messageService.add({
          key: 'cxcdepcli',
          severity: 'error',
          summary: 'Error',
          detail: 'Existen registros cuya fecha está vacía'
        });
        this.spin = false
        return;
      }
      if (compnull.length > 0) {
        this.messageService.add({
          key: 'cxcdepcli',
          severity: 'error',
          summary: 'Error',
          detail: 'Existen registros cuyo comprobante está vacío'
        });
        this.spin = false
        return;
      }
      if (importenull.length > 0) {
        this.messageService.add({
          key: 'cxcdepcli',
          severity: 'error',
          summary: 'Error',
          detail: 'Existen registros cuyo importe está vacío'
        });
        this.spin = false
        return;
      }

      if (codclinull.length > 0) {
        this.messageService.add({
          key: 'cxcdepcli',
          severity: 'error',
          summary: 'Error',
          detail: 'Existen registros cuyo código cliente está vacío'
        });

        // this.spin = false
        // return;
      }
      for (const [fecha, posiciones] of Array.from(fechaPosiciones.entries())) {
        const esValida = await this.esfechaValida(fecha, posiciones[0])
        if (esValida === false) {
          this.spin = false
          return;
        }
      }

      const cedulas = this.datosJson.map(({ FECHA, REFERENCIA, CONCEPTO, IMPORTE, ...resto }) => resto)


      const numdep = this.datosJson.map(item => (String(item.COMPROBANTE).trim()))

      const conteonum = this.datosJson.map(item => (item.COMPROBANTE)).reduce((acc, numero) => {
        acc[numero] = (acc[numero] || 0) + 1;
        return acc
      }, {});

      const reducenum = Object.entries(conteonum).map(([numero, cantidad]) => ({ numero, cantidad }));

      for (const iterator of reducenum) {
        if (iterator.cantidad > 1) {
          this.messageService.add({
            key: 'cxcdepcli',
            severity: 'error',
            summary: 'Información',
            detail: 'El comprobante ' + iterator.numero + ', está repetido'
          });
          this.spin = false;
          return
        }
      }
      await this.cxcdepositocliService.insertartmpdepcli(cedulas)

      const data1 = await this.cxcdepositocliService.validacedulas();

      const data2 = await this.cxcdepositocliService.getnomcli();
      const data3 = await this.cxcdepositocliService.getdepositos(numdep, this.cxcdepositocliService.encdepcli[this.indicador].BAN_CODIGO);
      const data4 = await this.cxcdepositocliService.getdepositosdetdepcli(numdep, this.cxcdepositocliService.encdepcli[this.indicador].BAN_CODIGO);

      if (data1 !== null && data1 !== undefined) {
        if (data1.length > 0) {
          const cadena = data1.map(item => String(item.CLI_CODIGO)).join(',')
          if (data1.length === 1) {
            this.messageService.add({
              key: 'cxcdepcli',
              severity: 'error',
              summary: 'Error',
              detail: 'Hubo un error al validar el siguiente código, por favor revisar ' + cadena
            });
          } else {
            this.messageService.add({
              key: 'cxcdepcli',
              severity: 'error',
              summary: 'Error',
              detail: 'Hubo un error al validar los siguientes códigos, por favor revisar ' + cadena
            });
          } 
          this.spin = false
          return;
        }
      }

      // this.spin = false;
      // return;

      numero = this.cxcdepositocliService.detdepcli.length + 1
      let nombrecli = '';
      let existereg = '';
      let existeregdetdepcli = '';
      let exisregcomprobante = '';

      for (const item of this.datosJson) {
        reg = {}
        reg.DETDEPCLI_REFERENCIA = isNullOrUndefined(item.REFERENCIA) ? '' : String(item.REFERENCIA).trim()
        reg.DETDEPCLI_COMPROBANTE = isNullOrUndefined(item.COMPROBANTE) ? '' : String(item.COMPROBANTE).trim()
        reg.DETDEPCLI_CONCEPTO = isNullOrUndefined(item.CONCEPTO) ? '' : String(item.CONCEPTO).trim()
        reg.DETDEPCLI_IMPORTE = isNullOrUndefined(item.IMPORTE) ? '' : Number(item.IMPORTE)
        reg.CLI_CODIGO = isNullOrUndefined(item.CODCLI) ? '' : String(item.CODCLI).trim()
        existereg = 'N'
        existeregdetdepcli = 'N';
        exisregcomprobante = 'N';

        reg.DETDEPCLI_REFERENCIA = reg.DETDEPCLI_REFERENCIA.toString().substring(0, 100);
        reg.DETDEPCLI_COMPROBANTE = reg.DETDEPCLI_COMPROBANTE.toString().substring(0, 50);
        reg.DETDEPCLI_CONCEPTO = reg.DETDEPCLI_CONCEPTO.toString().substring(0, 100)
        reg.DETDEPCLI_IMPORTE = this.utilitariosService.formatear(reg.DETDEPCLI_IMPORTE, 2)
        reg.DETDEPCLI_FECHA = item.FECHA.toString()//new Date(item.FECHA)

        if (item.FECHA.toString().includes('-')) {
          reg.DETDEPCLI_FECHA = this.datePipe.transform(item.FECHA, 'dd/MM/yyyy')
        }
        nombrecli = data2.find(element => element.CLI_RUCIDE === reg.CLI_CODIGO)?.CLI_NOMBRE || '';

        if ((data3.length === 0 || isNullOrUndefined(data3)) && (data4.length === 0 || isNullOrUndefined(data4))) {
          exisregcomprobante = 'N'
        } else {

          existereg = data3.find(element => element.TRNBAN_NUMERO === reg.DETDEPCLI_COMPROBANTE) ? 'Y' : 'N'
          existeregdetdepcli = data4.find(element => element.DETDEPCLI_COMPROBANTE === reg.DETDEPCLI_COMPROBANTE) ? 'Y' : 'N'

          //console.log(data3.find(element => element.TRNBAN_NUMERO === reg.DETDEPCLI_COMPROBANTE))
        }
        if (existereg === 'Y' || existeregdetdepcli === 'Y') {
          exisregcomprobante = 'Y'
        }
        let nuevodetRegcomp: Cxcdetdepcli = {
          DETDEPCLI_NUMERO: numero,
          ENCDEPCLI_NUMERO: '',
          COM_CODIGO: '01',
          BAN_CODIGO: this.cxcdepositocliService.encdepcli[this.indicador].BAN_CODIGO,
          DETDEPCLI_FECHA: reg.DETDEPCLI_FECHA,
          DETDEPCLI_REFERENCIA: reg.DETDEPCLI_REFERENCIA,
          DETDEPCLI_COMPROBANTE: reg.DETDEPCLI_COMPROBANTE,
          DETDEPCLI_CONCEPTO: reg.DETDEPCLI_CONCEPTO,
          DETDEPCLI_REFERENCIA2: '',
          CLI_CODIGO: reg.CLI_CODIGO,
          CLI_NOMBRE: nombrecli,
          DETDEPCLI_IMPORTE: reg.DETDEPCLI_IMPORTE,
          TRNCOBRO_NRODOC: '',
          COLOREXISTEDOC: exisregcomprobante,
          NUEVO: 'S'
        };
        //nuevodetreg.push(nuevodetRegcomp)
        this.cxcdepositocliService.detdepcli.push(nuevodetRegcomp);
        this.detdepcliSelected = nuevodetRegcomp;
        numero++;
      }
      // const resp = await this.cxcdepositocliService.getregistrartemporal()

      this.spin = false;
      this.cxcdepositocliService.calculartotal();
      this.aggrid.refreshaggrid(this.cxcdepositocliService.detdepcli, this.defaultCxdetdepcli.objeto);
      //console.log(this.cxcdepositocliService.detdepcli)

      this.spin = false;
    } catch (error) {
      this.messageService.add({
        key: 'cxcdepcli',
        severity: 'error',
        summary: 'Error',
        detail: 'Ocurrió un error al cargar los datos, por favor revise el formato de la plantilla y vuelva a cargar' + error
      });
      console.log(error)
      this.spin = false;
    }

  }
  async esfechaValida(fecha, posicion) {
    //console.log(typeof fecha)
    if (typeof fecha !== 'string') {
      return false
    }
    fecha = fecha.trim();
    if (fecha === '') {
      this.messageService.add({
        key: 'cxcdepcli',
        severity: 'error',
        summary: 'Error',
        detail: 'La fecha en la posición ' + posicion + ', está vacía'
      });
      //console.log('porque entra al vacío')
      return false
    }
    const regex = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/(\d{4})$/
    const match = fecha.match(regex);

    if (!match) {
      this.messageService.add({
        key: 'cxcdepcli',
        severity: 'error',
        summary: 'Error',
        detail: 'La fecha ' + fecha + ' en la posición ' + posicion + ' no está en el formato correcto dd/MM/yyyy'
      });
      //console.log('porque entra al match')
      return false
    }
    const dia = parseInt(match[1], 10)
    const mes = parseInt(match[2], 10)
    const anio = parseInt(match[3], 10)

    const date = new Date(anio, mes - 1, dia)

    const fechaCorrecta = date.getFullYear() === anio &&
      (date.getMonth() + 1) === mes &&
      date.getDate() === dia;

    // console.log('anio', anio)
    // console.log('mes', mes)
    // console.log('dia', dia)
    // console.log('date.getFullYear()', date.getFullYear())
    // console.log('date.getMonth()', date.getMonth() + 1)
    // console.log('date.getDate()', date.getDate())
    // console.log('date.getFullYear() === anio', date.getFullYear() === anio)
    // console.log('(date.getMonth() + 1) === mes', (date.getMonth() + 1) === mes)
    // console.log('date.getDate() === dia', date.getDate() === dia)

    if (await this.utilitariosService.verificarPeriodoContable(dia, mes - 1, anio) === false) {
      //console.log('porque entra')
      this.messageService.add({
        key: 'cxcdepcli',
        severity: 'error',
        summary: 'Error',
        detail: 'La fecha ' + fecha + ' en la posición '+posicion+' No está dentro del periodo contable '
      })
      return false
    }
    if (fechaCorrecta === false) {
      this.messageService.add({
        key: 'cxcdepcli',
        severity: 'error',
        summary: 'Error',
        detail: 'La fecha ' + fecha + ' en la posición '+posicion+' No es correcta, por favor revisar que exista '
      })
      return false
    }
    return true
  }
  confirmeliminaregistro() {
    this.confirmationService.confirm({
      message: 'Está seguro de eliminar el registro?',
      header: 'Pregunta',
      icon: 'pi pi-exclamation-triangle',
      key: 'confirmcxcdepcli',
      acceptLabel: 'Si',
      rejectLabel: 'No',
      accept: async () => {
        this.confirmationService.close();
        try {
          let cod = this.cxcdepositocliService.encdepcli[this.indicador].ENCDEPCLI_NUMERO
          if (isNullOrUndefined(cod) || cod === '') {
            this.cxcdepositocliService.detdepcli = this.cxcdepositocliService.detdepcli.filter((val, j) => j !==
              this.cxcdepositocliService.detdepcli.indexOf(this.detdepcliSelected));
            this.cxcdepositocliService.calculartotal()
            this.aggrid.refreshaggrid(this.cxcdepositocliService.detdepcli, this.defaultCxdetdepcli.objeto);
          } else {
            await this.cxcdepositocliService.eliminadetregistro(this.detdepcliSelected);

            await this.auditoriagral.registrarAuditoria('CXC_DETDEPCLI',
              this.detdepcliSelected.ENCDEPCLI_NUMERO + '/Banco:' + this.detdepcliSelected.BAN_CODIGO
              + '/Comp:' + this.detdepcliSelected.DETDEPCLI_COMPROBANTE + '/CodCli:' + this.detdepcliSelected.CLI_CODIGO, 'E',
              '', '01', '', '', '', '').toPromise();

            this.cxcdepositocliService.detdepcli = this.cxcdepositocliService.detdepcli.filter((val, j) => j !==
              this.cxcdepositocliService.detdepcli.indexOf(this.detdepcliSelected));
            this.cxcdepositocliService.calculartotal()
            this.aggrid.refreshaggrid(this.cxcdepositocliService.detdepcli, this.defaultCxdetdepcli.objeto);
          }

        } catch (error) {
          this.messageService.add({
            key: 'cxcdepcli',
            severity: 'error',
            summary: 'Información',
            detail: 'Ocurrió un erro durante la eliminación ' + error.error
          });
        }
      },
      reject: () => {
        this.confirmationService.close();
      }
    });
  }
  botonesmodificar() {
    this.botonNuevo = true;
    this.botonGuardar = false;
    this.botonBorrar = true;
    this.botonRegresar = false;
    this.botonPrimero = false;
    this.botonAnterior = false;
    this.botonSiguiente = false;
    this.botonUltimo = false;
  }
  setFocus(event) {
    let element: any;
    switch (event.target.id) {
      case 'BAN_CODIGO': {
        this.busquedabanco(event.target.value);
        break;
      }
      default: {
        break;
      }
    }
  }
  validaciboolena(params) {
    if (params.data.TRNCOBRO_NRODOC === '' || isNullOrUndefined(params.data.TRNCOBRO_NRODOC)) {
      this.botonNuevo = true;
      this.botonGuardar = false;
      this.botonBorrar = true;
      this.botonRegresar = false;
      this.botonPrimero = false;
      this.botonAnterior = false;
      this.botonSiguiente = false;
      this.botonUltimo = false;
      return true
    } else {
      this.botonNuevo = false;
      this.botonGuardar = true;
      this.botonBorrar = false;
      this.botonRegresar = true;
      this.botonPrimero = true;
      this.botonAnterior = true;
      this.botonSiguiente = true;
      this.botonUltimo = true;
      return false
    }
  }
}
